var __esDecorate = (this && this.__esDecorate) || function (ctor, descriptorIn, decorators, contextIn, initializers, extraInitializers) {
    function accept(f) { if (f !== void 0 && typeof f !== "function") throw new TypeError("Function expected"); return f; }
    var kind = contextIn.kind, key = kind === "getter" ? "get" : kind === "setter" ? "set" : "value";
    var target = !descriptorIn && ctor ? contextIn["static"] ? ctor : ctor.prototype : null;
    var descriptor = descriptorIn || (target ? Object.getOwnPropertyDescriptor(target, contextIn.name) : {});
    var _, done = false;
    for (var i = decorators.length - 1; i >= 0; i--) {
        var context = {};
        for (var p in contextIn) context[p] = p === "access" ? {} : contextIn[p];
        for (var p in contextIn.access) context.access[p] = contextIn.access[p];
        context.addInitializer = function (f) { if (done) throw new TypeError("Cannot add initializers after decoration has completed"); extraInitializers.push(accept(f || null)); };
        var result = (0, decorators[i])(kind === "accessor" ? { get: descriptor.get, set: descriptor.set } : descriptor[key], context);
        if (kind === "accessor") {
            if (result === void 0) continue;
            if (result === null || typeof result !== "object") throw new TypeError("Object expected");
            if (_ = accept(result.get)) descriptor.get = _;
            if (_ = accept(result.set)) descriptor.set = _;
            if (_ = accept(result.init)) initializers.unshift(_);
        }
        else if (_ = accept(result)) {
            if (kind === "field") initializers.unshift(_);
            else descriptor[key] = _;
        }
    }
    if (target) Object.defineProperty(target, contextIn.name, descriptor);
    done = true;
};
var __runInitializers = (this && this.__runInitializers) || function (thisArg, initializers, value) {
    var useValue = arguments.length > 2;
    for (var i = 0; i < initializers.length; i++) {
        value = useValue ? initializers[i].call(thisArg, value) : initializers[i].call(thisArg);
    }
    return useValue ? value : void 0;
};
var __setFunctionName = (this && this.__setFunctionName) || function (f, name, prefix) {
    if (typeof name === "symbol") name = name.description ? "[".concat(name.description, "]") : "";
    return Object.defineProperty(f, "name", { configurable: true, value: prefix ? "".concat(prefix, " ", name) : name });
};
var __classPrivateFieldGet = (this && this.__classPrivateFieldGet) || function (receiver, state, kind, f) {
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a getter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot read private member from an object whose class did not declare it");
    return kind === "m" ? f : kind === "a" ? f.call(receiver) : f ? f.value : state.get(receiver);
};
var __classPrivateFieldSet = (this && this.__classPrivateFieldSet) || function (receiver, state, value, kind, f) {
    if (kind === "m") throw new TypeError("Private method is not writable");
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a setter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot write private member to an object whose class did not declare it");
    return (kind === "a" ? f.call(receiver, value) : f ? f.value = value : state.set(receiver, value)), value;
};
import { html } from 'lit';
import { queryAssignedElements } from 'lit/decorators.js';
import { SdsSelect } from '../../dropdown/select/sds-select.lit';
import { SdsInputPrefixSuffixBase } from '../_sds-input-prefix-suffix-base';
import { sdsCustomElement } from '../../utilities/custom-components';
/**
 * Control that represents Input Prefix.
 *
 * @slot - This slot is the container for the input component
 * @slot prefix - This slot is the container for the prefix component
 */
let SdsInputPrefix = (() => {
    var _SdsInputPrefix__prefixes_accessor_storage;
    let _classDecorators = [sdsCustomElement('sds-input-prefix')];
    let _classDescriptor;
    let _classExtraInitializers = [];
    let _classThis;
    let _classSuper = SdsInputPrefixSuffixBase;
    let __prefixes_decorators;
    let __prefixes_initializers = [];
    let __prefixes_extraInitializers = [];
    var SdsInputPrefix = _classThis = class extends _classSuper {
        constructor() {
            super(...arguments);
            _SdsInputPrefix__prefixes_accessor_storage.set(this, __runInitializers(this, __prefixes_initializers, void 0));
            this.prefixSlotChangeHandler = (__runInitializers(this, __prefixes_extraInitializers), () => {
                var _a, _b;
                if (this._prefixes[0] instanceof SdsSelect) {
                    (_b = (_a = this._prefixes[0].shadowRoot) === null || _a === void 0 ? void 0 : _a.querySelector('sds-input-select')) === null || _b === void 0 ? void 0 : _b.setAttribute('prefix', '');
                    this._prefixes[0].addEventListener(SdsSelect.SELECTED_EVENT, this.prefixSelectedHandler);
                }
            });
            this.prefixSelectedHandler = (event) => {
                this.dispatchPrefixSelected(event.detail.identifier);
            };
        }
        get _prefixes() { return __classPrivateFieldGet(this, _SdsInputPrefix__prefixes_accessor_storage, "f"); }
        set _prefixes(value) { __classPrivateFieldSet(this, _SdsInputPrefix__prefixes_accessor_storage, value, "f"); }
        render() {
            this.addGlobalStyle();
            return html `
            <div id="container" class="${this.getClasses()}">
                ${this.renderLabel()}
                <slot name="prefix" @slotchange="${this.prefixSlotChangeHandler}"></slot>
                <slot @slotchange="${this.inputSlotChangeHandler}"></slot>
            </div>
            ${this.renderError()}
        `;
        }
        renderError() {
            if (this.errorMessage && this.invalid) {
                return html `
                <sds-error style="margin-top: 4px;" message="${this.errorMessage}"></sds-error>
            `;
            }
        }
        addEventListener(type, listener, options) {
            super.addEventListener(type, listener, options);
        }
        dispatchPrefixSelected(identifier) {
            this.dispatchEvent(new CustomEvent(SdsInputPrefix.PREFIX_SELECTED, {
                detail: {
                    identifier: identifier,
                },
            }));
        }
    };
    _SdsInputPrefix__prefixes_accessor_storage = new WeakMap();
    __setFunctionName(_classThis, "SdsInputPrefix");
    (() => {
        var _a;
        const _metadata = typeof Symbol === "function" && Symbol.metadata ? Object.create((_a = _classSuper[Symbol.metadata]) !== null && _a !== void 0 ? _a : null) : void 0;
        __prefixes_decorators = [queryAssignedElements({ slot: 'prefix' })];
        __esDecorate(_classThis, null, __prefixes_decorators, { kind: "accessor", name: "_prefixes", static: false, private: false, access: { has: obj => "_prefixes" in obj, get: obj => obj._prefixes, set: (obj, value) => { obj._prefixes = value; } }, metadata: _metadata }, __prefixes_initializers, __prefixes_extraInitializers);
        __esDecorate(null, _classDescriptor = { value: _classThis }, _classDecorators, { kind: "class", name: _classThis.name, metadata: _metadata }, null, _classExtraInitializers);
        SdsInputPrefix = _classThis = _classDescriptor.value;
        if (_metadata) Object.defineProperty(_classThis, Symbol.metadata, { enumerable: true, configurable: true, writable: true, value: _metadata });
    })();
    _classThis.PREFIX_SELECTED = 'sds.prefix.selected';
    (() => {
        __runInitializers(_classThis, _classExtraInitializers);
    })();
    return SdsInputPrefix = _classThis;
})();
export { SdsInputPrefix };
